import * as React from 'react';

import { Html5CreativePreview } from '../../canvas/Html5CreativePreview/Html5CreativePreview';
import { ImageCreativePreview } from '../../canvas/ImageCreativePreview/ImageCreativePreview';
import { VideoCreativePreview } from '../../canvas/VideoCreativePreview/VideoCreativePreview';
import { Bem } from '../../service/Bem/Bem';
import { BannerViewType, PcodeRenderData } from '../../typings/pcode';
import { ModalDecorator } from '../ModalDecorator/ModalDecorator';

import './CreativePreviewIFrame.css';

export interface CreativeCanvasIFrameProps {
    previewData: PcodeRenderData;
    previewUrl?: string;
    onOutsideClick: () => void;
    isVisible: boolean;
    cspNonce: string;
}

export class CreativePreviewIFrame extends React.PureComponent<CreativeCanvasIFrameProps> {
    render() {
        const { previewData, onOutsideClick, isVisible } = this.props;
        const { type, size } = previewData;
        let width;
        let height;

        switch (type) {
            case BannerViewType.adaptive0418:
            case BannerViewType.html5CreativePreview:
            default:
                width = (size && size.width) || undefined;
                height = (size && size.height) || undefined;
                break;
        }

        return (
            <ModalDecorator
                visible={Boolean(isVisible)}
                cls={Bem.cls('creative-preview-iframe')}
                theme="clear"
                onOutsideClick={onOutsideClick}
            >
                {isVisible && this.renderPreview(height, width)}
            </ModalDecorator>
        );
    }

    private renderPreview = (height: number | undefined, width: number | undefined) => {
        const { previewData, previewUrl, cspNonce } = this.props;

        switch (previewData.type) {
            case BannerViewType.plainImagePreview:
                return <img src={previewUrl} height={height} width={width} />;

            case BannerViewType.adaptive0418:
                return <ImageCreativePreview previewUrl={previewUrl || ''} width={width} height={height} />;

            case BannerViewType.html5CreativePreview:
                return (
                    <Html5CreativePreview
                        previewUrl={previewUrl || ''}
                        cspNonce={cspNonce}
                        width={width}
                        height={height}
                    />
                );

            case BannerViewType.videoAdditionPreview:
                return <VideoCreativePreview previewData={previewData} previewUrl={previewUrl || ''} />;

            default:
                return null;
        }
    };
}
